// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"style_wrap_7c9dbfa19742ff2a5364d60da475cdc6"};